import { getRandomNumber } from '../math/index.js';

// function creates a cookie with expiration date in n days
const createCookie = (name, days = 1, value = 1) => {
    let expires;
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    else {
        expires = '';
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
};
const searchService = (url, term, size, offset, language) => fetch(url, {
    method: 'POST',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        term,
        size,
        offset,
        language,
    }),
});
const isSameOrigin = (uri1, uri2 = window.location.href) => {
    const url1 = new URL(uri1, window.location.origin);
    const url2 = new URL(uri2);
    if (url1.host !== url2.host)
        return false;
    if (url1.port !== url2.port)
        return false;
    return url1.protocol === url2.protocol;
};
const doMockApiCall = (mockData, hasError = false) => new Promise(resolve => {
    if (hasError)
        throw new Error('Mock API call has failed as expected');
    setTimeout(() => resolve(mockData), getRandomNumber() * 1000);
});
const getCookie = (name) => {
    const cookies = Object.assign({}, ...document.cookie.split('; ').map(cookie => {
        const cookieName = cookie.split('=')[0];
        const cookieValue = cookie.split('=')[1];
        return { [cookieName]: cookieValue };
    }));
    return cookies[name];
};

export { createCookie, doMockApiCall, getCookie, isSameOrigin, searchService };
